import { get } from "./api";

export function cookiesGet(proofUuid) {
  return get(`/v1/account/cookies/get?uuid=${proofUuid}`);
}
